<!--
  AI:
  Status: "in progress"
  Type: Component
  SubType: CrudIntegration
  Reason: Full view template for LogicFlow OBC — version status bar, read-only banner, flow designer, test runner, execution monitor, and messages.
-->
@if (initialized && dto) {

    <!-- Version status bar -->
    <div class="flex align-items-center justify-content-between px-4 py-3 surface-0 border-bottom-1 surface-border">
        <div class="flex align-items-center gap-2">
            <p-tag [value]="flowStatusLabel" [severity]="flowStatusSeverity" [icon]="flowStatusIcon"></p-tag>
            <span class="text-color-secondary text-sm">Version {{ flowVersion }}</span>
        </div>
        <div class="flex align-items-center gap-2">
            @if (flowStatus === LogicFlowStatusEnum.DRAFT) {
                <p-button label="Veröffentlichen" icon="fa-regular fa-check" severity="success" size="small" (onClick)="publishFlow()" [loading]="publishing"></p-button>
            }
            @if (flowStatus === LogicFlowStatusEnum.PUBLISHED) {
                <p-button label="Neue Version" icon="fa-regular fa-copy" severity="info" size="small" (onClick)="createNewVersion()" [loading]="creatingVersion"></p-button>
            }
            <p-button label="Exportieren" icon="fa-regular fa-download" [text]="true" size="small" (onClick)="exportFlow()"></p-button>
        </div>
    </div>

    @if (isPublished) {
        <div class="flex align-items-center gap-2 px-4 py-2 bg-blue-50 border-bottom-1 border-blue-200">
            <i class="fa-regular fa-circle-info text-blue-500"></i>
            <span class="text-blue-700 text-sm">Dieser Flow ist veröffentlicht und kann nicht bearbeitet werden. Erstellen Sie eine neue Version, um Änderungen vorzunehmen.</span>
        </div>
    }

    @if (activeNavigationItem?.action === 'designer') {
        <!-- TM-1000001563: [flowImports]/[flowExports] pass declared schema to Start/End cards -->
        <!-- TM-1000001563: removed `(editStep)` consumer hookup — the designer
             no longer emits `editStep` (its `(dblclick)` source was deleted
             in Item 1). -->
        <!-- TM-1000001563: [flowId] enables backend layout persistence; -->
        <!-- TM-1000001563: [layoutJson] feeds the saved layout synchronously so
             the canvas seeds with the persisted positions on first paint
             instead of after an async GET (the parent OBC already loaded the
             LogicFlow object including layoutJson into `dto`). -->
        <lg-flow-designer
                [steps]="flowSteps"
                [flowId]="objectIdentifier?.objectId"
                [layoutJson]="dto?.layoutJson"
                [resolvedSteps]="resolvedFlow?.steps"
                [overrideMap]="resolvedFlow?.overrideMap"
                [readonly]="isPublished"
                [flowImports]="flowImportsList"
                [flowExports]="flowExportsList"
                (selectedStep)="onFlowStepSelected($event)">
        </lg-flow-designer>
    }

    @if (activeNavigationItem?.action === 'tests') {
        <mvs-lg-test-runner
                [flowId]="objectIdentifier.objectId">
        </mvs-lg-test-runner>
    }

    @if (activeNavigationItem?.action === 'executions') {
        <mvs-lg-execution-monitor
                [flowId]="objectIdentifier.objectId">
        </mvs-lg-execution-monitor>
    }

    @if (activeNavigationItem?.action === 'messages') {
        <div class="p-3">
            <p class="text-color-secondary">Nachrichten werden über den Ausführungsmonitor angezeigt.</p>
        </div>
    }
}

<!-- TM-1000001563: Removed duplicate <p-confirmDialog/>; relying on the global instance in app.main.component.html -->

